import {
  scrollbarSx_default
} from "./chunk-GD6E42CP.mjs";

// src/PopoverMenuCell.tsx
import { useState } from "react";
import Box from "@mui/material/Box/index.js";
import Popover from "@mui/material/Popover/index.js";
import { useTheme } from "@mui/material/styles/index.js";
import { jsx, jsxs } from "react/jsx-runtime";
var PopoverMenuCell = ({
  trigger,
  children,
  ariaLabel,
  disabled = false,
  width = 320
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.stopPropagation();
    if (disabled) return;
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);
  return /* @__PURE__ */ jsxs(Box, { "aria-label": ariaLabel, sx: { display: "inline-flex" }, children: [
    trigger({ onClick: handleClick, open }),
    /* @__PURE__ */ jsx(
      Popover,
      {
        elevation: 0,
        open,
        anchorEl,
        onClose: handleClose,
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
        PaperProps: {
          sx: {
            marginTop: 1,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            width,
            maxWidth: "90vw",
            maxHeight: "70vh",
            overflowY: "auto",
            overflowX: "hidden",
            padding: 2,
            ...scrollbarSx_default
          }
        },
        children
      }
    )
  ] });
};
var PopoverMenuCell_default = PopoverMenuCell;

export {
  PopoverMenuCell_default
};
